import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ILocationBusinessModel } from '@shared/state';

@Component({
    selector: 'shared-modal-for-location-open-hours',
    templateUrl: './modal-for-location-open-hours.shared.component.html',
    styleUrls: ['./modal-for-location-open-hours.shared.component.scss']
})
export class ModalForLocationOpenHoursComponent extends ModalViewComponent implements OnInit {
    private _locationNo!: number;
    public locationDetails$!: Observable<ILocationBusinessModel>;
    public locationOpenHours$!: Observable<APICommon.LocationOrderingTimeInfoExtendedModel[]>;
    public locationAddress$!: Observable<string>;

    public showChangeLocationBtn$: Observable<boolean>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
        public routeService: Services.RouteService,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this._locationNo = this.modalData.locationNo;

        this.locationDetails$ = this.controllers.locations.locationDetails$(this._locationNo);
        this.locationOpenHours$ = this.controllers.locations.openingHours$(this._locationNo);
        this.locationAddress$ = this.controllers.locations.locationAddress$(this._locationNo);
        this.size = 'xsm';
    }

    public handleViewMenuClick($event: Event): void {
        this.handleCloseClick(null);
        this.routeService.navigateToLocation(this._locationNo);
    }

    public handleChangeLocationClick($event: Event): void {
        this.handleCloseClick(null);
        this.controllers.routes.navigateToLocationsSearchView();
    }

    public handleAddressClick($event: Event): void {
        this.controllers.locations.googleMapsLocationAddressLink$(this._locationNo)
            .pipe(
                take(1),
            )
            .subscribe(link => {
                if (link) {
                    window.open(link, '_blank').focus();
                }
            });
    }
}
